import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";

var PHRASES = [
  "Thinking through this",
  "Reasoning through your question",
  "Connecting the pieces",
  "Working through the details",
  "Creating visuals",
  "Refining the answer",
  "Going a bit deeper",
  "Cross-checking the details",
  "Found something",
  "Thinking deeper",
  "Putting the answer together",
];

var useStyles = makeStyles(() => ({
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "-200% 0" },
    "100%": { backgroundPosition: "200% 0" },
  },
  "@keyframes pulseGlow": {
    "0%, 100%": { boxShadow: "0 0 0 0 rgba(37, 99, 235, 0.35)" },
    "50%": { boxShadow: "0 0 0 6px rgba(37, 99, 235, 0)" },
  },
  "@keyframes phraseIn": {
    "0%": { opacity: 0, transform: "translateY(6px)" },
    "100%": { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes dotPulse": {
    "0%, 100%": { opacity: 0.3 },
    "50%": { opacity: 1 },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#1e3a5f",
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "'DM Sans', sans-serif",
  },
  labelIcon: {
    width: "22px",
    height: "22px",
    borderRadius: "6px",
    background: "linear-gradient(135deg, #1e3a5f, #2563eb)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#fff",
    fontSize: "9px",
    fontWeight: 700,
    letterSpacing: "0.5px",
    animation: "$pulseGlow 2s ease-in-out infinite",
  },
  phraseSpan: {
    display: "inline-block",
    animation: "$phraseIn 250ms ease-out",
  },
  dots: {
    display: "inline-flex",
    gap: "1px",
    marginLeft: "1px",
  },
  dot: {
    animation: "$dotPulse 1.4s ease-in-out infinite",
  },
  dot1: { animationDelay: "0s" },
  dot2: { animationDelay: "0.2s" },
  dot3: { animationDelay: "0.4s" },
  shimmerBlock: {
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "$shimmer 1.5s infinite linear",
    borderRadius: "4px",
    height: "14px",
  },
  line1: { width: "90%" },
  line2: { width: "70%" },
  line3: { width: "85%" },
  kpiRow: {
    display: "flex",
    gap: "10px",
    marginTop: "4px",
  },
  kpiBlock: {
    flex: 1,
    height: "70px",
    borderRadius: "10px",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "$shimmer 1.5s infinite linear",
  },
}));

var TypingIndicator = function TypingIndicator() {
  var classes = useStyles();
  var [index, setIndex] = useState(0);

  useEffect(function () {
    var id = setInterval(function () {
      setIndex(function (prev) {
        return Math.min(prev + 1, PHRASES.length - 1);
      });
    }, 1800);
    return function () { clearInterval(id); };
  }, []);

  return (
    <div>
      <div className={classes.label}>
        <span className={classes.labelIcon}>NQ</span>
        <span key={index} className={classes.phraseSpan}>
          {PHRASES[index]}
        </span>
        <span className={classes.dots}>
          <span className={classes.dot + " " + classes.dot1}>.</span>
          <span className={classes.dot + " " + classes.dot2}>.</span>
          <span className={classes.dot + " " + classes.dot3}>.</span>
        </span>
      </div>
      <div className={classes.container}>
        <div className={classes.shimmerBlock + " " + classes.line1} />
        <div className={classes.shimmerBlock + " " + classes.line2} />
        <div className={classes.shimmerBlock + " " + classes.line3} />
        <div className={classes.kpiRow}>
          <div className={classes.kpiBlock} />
          <div className={classes.kpiBlock} />
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
